/* @minVersion 7.0.0-beta.0 */

var id = 0;
export default function _classPrivateFieldKey(name: string) {
  return "__private_" + id++ + "_" + name;
}
